/**
 * §6.10's address, in one place.
 *
 * ⚠️ **`navItems.ts` keeps its own literal on purpose**, the way `QUESTIONS_PATH`'s module records: the
 * sidebar's table is the *specification* of §5 and reads as such, while `routes.tsx` must mount exactly
 * the address the sidebar links to. `app.test.tsx`'s "no address is mounted twice" plus
 * `unbuiltNavItems()`'s derivation are what tie the two together — a route mounted at a path no
 * `NAV_ITEMS` row names would leave `/settings` in the placeholder list and shadow this screen.
 */
export const SETTINGS_PATH = '/settings';
